import { SPECIFIC } from 'sales-content-partitioning/constants/SharingOptionTypes';
function areArraysEqual(first, second) {
  if (first.length !== second.length) {
    return false;
  }
  return first.every((el, idx) => second[idx] === el);
}
export function validateSelectedOptions({
  sharingOption,
  selectedTeams,
  selectedUsers
}) {
  return sharingOption === SPECIFIC ? selectedTeams.length > 0 || selectedUsers.length > 1 : true;
}
export function allowSave({
  canAssignContent,
  selectedTeams,
  selectedUsers,
  sharingOption,
  initialSelectedTeams,
  initialSelectedUsers,
  initialSharingOption,
  enableSaveWithoutPermissionChange
}) {
  if (sharingOption === SPECIFIC) {
    const teamsOrUsersChanged = !areArraysEqual(selectedTeams, initialSelectedTeams) || !areArraysEqual(selectedUsers, initialSelectedUsers);
    return canAssignContent && teamsOrUsersChanged && validateSelectedOptions({
      sharingOption,
      selectedTeams,
      selectedUsers
    });
  }
  if (sharingOption === null) {
    // Must have one option selected
    return false;
  }
  if (enableSaveWithoutPermissionChange) {
    return true;
  }
  return initialSharingOption !== sharingOption;
}